// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBAJgQZwCtuuFiFtGyKIVm_GPLtpX1s4OQ",
  authDomain: "portfolio-89d91.firebaseapp.com",
  projectId: "portfolio-89d91",
  storageBucket: "portfolio-89d91.firebasestorage.app",
  messagingSenderId: "104186921103",
  appId: "1:104186921103:web:e16eac8730c0f78bcd70fa",
  measurementId: "G-8FCLST4MYH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();